import React from 'react'
import styled from 'styled-components'
import { Text } from '@pancakeswap-libs/uikit'
import { addToMetamask } from 'utils/metamaskUtils'
import MetamaskButton from 'components/Metamask/AddToMetamask'
import Logo from 'components/Logo'

export interface ExpandableSectionProps {
  token: any
}

const Wrapper = styled.div`
  margin-bottom: 24px;
`

const ImageWrapper = styled.div`
  text-align: center;
`

const Image = styled(Logo)`
  height: 64px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
`

const LabelWrapper = styled(Text)`
  font-family: 'Verdana',sans-serif;
  text-align: center;
  word-break: break-word;
`

const NameWrapper = styled(LabelWrapper)`
  font-size: 22px;
  padding-bottom: 5px;
`

const SymbolWrapper = styled(LabelWrapper)`
  font-size: 16px;
  padding-bottom: 18px;
`

const CardHeading: React.FC<ExpandableSectionProps> = ({
  token
}) => {
  const addTokenToMetamask = ()=>{
    addToMetamask(token.address, token.symbol, token.decimals, `https://asset.benswap.cash/assets/${token.address}/logo.png`);
  };
  return (
    <Wrapper>
      <NameWrapper>{token.name}</NameWrapper>
      <SymbolWrapper>({token.symbol})</SymbolWrapper>
      <ImageWrapper>
        <Image srcs={[`https://asset.benswap.cash/assets/${token.address}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={`${token.symbol} Logo`} />
        <MetamaskButton onClick={addTokenToMetamask} />
      </ImageWrapper>
    </Wrapper>
  )
}

export default CardHeading
